/* unplugin-vue-components disabled */import { render } from "./goodsScroll.vue?vue&type=template&id=393d2e4f&scoped=true"
import script from "./goodsScroll.vue?vue&type=script&lang=js"
export * from "./goodsScroll.vue?vue&type=script&lang=js"

import "./goodsScroll.vue?vue&type=style&index=0&id=393d2e4f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393d2e4f"]])

export default __exports__